<div class="p-3">
  <div class="page-title d-flex justify-content-between align-items-center px-1 mb-3">
    <h3>Yardi Guest Cards <span class="internal-badge">Internal</span></h3>
    <p-button type="button" icon="pi pi-sync" class="primary-btn p-button-secondary"
      pTooltip="Reset Filters" (click)="resetFilters()"></p-button>
  </div>

  <!-- Filters -->
  <div class="filters mb-3">
    <div class="row g-2">
      <div class="col-lg-3 col-sm-6 col-12">
        <label class="dropdown-label">Search (name, email, phone, unit, floorplan)</label>
        <input type="text" pInputText placeholder="Search..." class="form-control"
          [(ngModel)]="filters.search" (input)="onFilterChange()" />
      </div>

      <div class="col-lg-2 col-sm-6 col-12">
        <label class="dropdown-label">Message Status</label>
        <p-dropdown [options]="messageStatusOptions" [(ngModel)]="filters.message_status"
          placeholder="All Statuses" [showClear]="true" (onChange)="onFilterChange()"></p-dropdown>
      </div>

      <div class="col-lg-2 col-sm-6 col-12">
        <label class="dropdown-label">Lead Source</label>
        <p-dropdown [options]="leadSourceOptions" [(ngModel)]="filters.prospect_source"
          placeholder="All Sources" [showClear]="true" filter="true"
          (onChange)="onFilterChange()"></p-dropdown>
      </div>

      <div class="col-lg-2 col-sm-6 col-12">
        <label class="dropdown-label">Property Source ID</label>
        <p-dropdown [options]="propertySourceOptions" [(ngModel)]="filters.yardi_property_source_id"
          placeholder="All Properties" [showClear]="true" filter="true"
          (onChange)="onFilterChange()"></p-dropdown>
      </div>

      <div class="col-lg-3 col-sm-6 col-12">
        <label class="dropdown-label">Created Date Range</label>
        <p-calendar [(ngModel)]="filters.dateRange" selectionMode="range" dateFormat="mm/dd/yy"
          appendTo="body" placeholder="Select Date Range" [showIcon]="true" [numberOfMonths]="2"
          [showClear]="true" (ngModelChange)="onDateRangeChange($event)"></p-calendar>
      </div>
    </div>
  </div>

  <!-- Table -->
  <p-table
    [value]="guestCards"
    [lazy]="true"
    [paginator]="true"
    [rows]="rowsPerPage"
    [rowsPerPageOptions]="[10, 20, 50]"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    (onLazyLoad)="loadGuestCards($event)"
    responsiveLayout="scroll"
    styleClass="p-datatable-sm p-datatable-gridlines">

    <ng-template pTemplate="header">
      <tr>
        <th>Prospect ID</th>
        <th>Name</th>
        <th>Email</th>
        <th>Phone</th>
        <th>Lead Source</th>
        <th>Property Source ID</th>
        <!-- <th>Move-In Date</th> -->
        <th>Desired Unit</th>
        <th>Desired Floorplan</th>
        <th>Target Move-In</th>
        <th>Bedrooms</th>
        <th>Desired Rent</th>
        <th>Msg Status</th>
        <th>Tour Sync</th>
        <th>Last Pulled</th>
        <th>Created At</th>
        <th>Updated At</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-card>
      <tr>
        <td>
          <span class="prospect-id" pTooltip="{{ card.prospect_id }}">{{ card.prospect_id }}</span>
        </td>
        <td>{{ getFullName(card) }}</td>
        <td>{{ getEmail(card) }}</td>
        <td>{{ getPhone(card) }}</td>
        <td>{{ card.prospect_source || '—' }}</td>
        <td>{{ card.yardi_property_source_id || '—' }}</td>
        <!-- <td>{{ getMoveInDate(card) }}</td> -->
        <td>{{ getDesiredUnit(card) }}</td>
        <td>{{ getDesiredFloorplan(card) }}</td>
        <td>{{ getTargetMoveIn(card) }}</td>
        <td>{{ getDesiredBedrooms(card) }}</td>
        <td>{{ getDesiredRent(card) }}</td>
        <td>
          <p-tag [value]="card.message_status | titlecase"
            [severity]="getStatusSeverity(card.message_status)"></p-tag>
          <div *ngIf="card.message_status === 'pending'" class="status-note"
            pTooltip="Message not sent yet. Awaiting send (may have invalid phone)"
            tooltipPosition="top">
            Awaiting send
          </div>
          <div *ngIf="card.message_status === 'failed' && card.message_failed_reason"
            class="failed-reason" pTooltip="{{ card.message_failed_reason }}" tooltipPosition="top">
            {{ card.message_failed_reason }}
          </div>
        </td>
        <td>
          <p-tag
            [value]="getSyncLabel(card.yardi_guest_card_sync, card.has_yardi_tour)"
            [severity]="getSyncSeverity(card.yardi_guest_card_sync, card.has_yardi_tour)"
            [pTooltip]="getSyncTooltip(card.yardi_guest_card_sync, card.has_yardi_tour)"
            tooltipPosition="left">
          </p-tag>
        </td>
        <td>{{ card.last_pulled_at ? (card.last_pulled_at | date:'MM/dd/yyyy HH:mm') : '—' }}</td>
        <td>{{ card.createdAt | date:'MM/dd/yyyy HH:mm' }}</td>
        <td>{{ card.updatedAt | date:'MM/dd/yyyy HH:mm' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="17" class="text-center py-4">No guest cards found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
